export function cleanPlan(planName, carrierNameRegex) {
    let planNameReplaced = planName.replace(carrierNameRegex, '').trim();

    if (planNameReplaced.startsWith('-')) {
        planNameReplaced = planNameReplaced.substring(1).trim();
    }

    if (planNameReplaced) {
        return planNameReplaced;
    }

    return planName;
}
